/*global define, dna*/
define('core/services/SubHeaderService',['angular'], function (angular) {
    'use strict';
    angular.module('dnaApp').service('SubHeaderService', ['$http', function ($http) {
        var _breadCrumbs = [];

        /**
         * @class BreadCrumb
         * @param {String} text The text this breadcrumb should display.
         * @param {String} href The url, if this breadcrumb should be a link.
         * @constructor
         */
        function BreadCrumb(text, href, callback, target) {
            this.text = text;
            this.href = href;
            this.callback = callback;
            this.target = target;
        }

        /**
         * @class SubHeaderService
         */
        return {
            /**
             * @method getBreadCrumbs
             * @desc Returns the current breadcrumbs.
             * @returns {Array}
             * @public
             */
            getBreadCrumbs: function () {
                return _breadCrumbs;
            },

            /**
             * @method setBreadCrumbs
             * @desc Sets the breadcrumbs to the given array of breadcrumbs.
             * @param {Array} breadCrumbs
             * @public
             */
            setBreadCrumbs: function (breadCrumbs) {
                _breadCrumbs = breadCrumbs;
            },

            /**
             * @method breadCrumbFactory
             * @desc Creates breadcrumbs.
             * @param {String} text The text this breadcrumb should display.
             * @param {String} href The url, if this breadcrumb should be a link.
             * @param {function} callback, function called when link clicked
             * @returns {BreadCrumb}
             * @public
             */
            breadCrumbFactory: function (text, href, callback, target) {
                return new BreadCrumb(text, href, callback, target);
            }
        };
    }]);
});

